export type IAddressChangeFormFirstSection = {
    DateOfRequest?: string;
}

export const AddressChangeFormFirstSectionInitialState = (): IAddressChangeFormFirstSection => ({
    DateOfRequest: undefined
})